import { render, staticRenderFns } from "./form-edit-articles.vue?vue&type=template&id=71de55ae&scoped=true"
import script from "./form-edit-articles.vue?vue&type=script&lang=js"
export * from "./form-edit-articles.vue?vue&type=script&lang=js"
import style0 from "./form-edit-articles.vue?vue&type=style&index=0&id=71de55ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de55ae",
  null
  
)

export default component.exports